import constant from "../../constant";
import axios from "axios";

const api = constant.api + "statistics";
// initial state
const state = () => ({
  all: [],
  totalTodays: [],
  totals: [],
  quantityAnalytics: [],
  deliveries: [],
});

// getters
const getters = {
  getAll: (state) => state.all,

  getTotalTodays: (state) => state.totalTodays,
  getTotals: (state) => state.totals,

  getDeliveries: (state) => state.deliveries,
  getBarTodaysChartData: (state) => {
    return {
      labels: ["Total Ventes", "Payé", "Impayé", "Règlement "],
      datasets: [
        {
          label: "Ventes",
          data: state.totalTodays ? Object.values(state.totalTodays.sales) : [],
          backgroundColor: ["#0dcaf0", "#198754", "#dc3545", "#fd7e14"],
          borderColor: "rgba(75, 192, 192, 1)",
          borderWidth: 1,
        },
      ],
    };
  },

  getQuantityAnalytics: (state) => state.quantityAnalytics,
};

// actions
const actions = {
  async downloadDailySheet({ commit }, data) {
    try {
      const response = await axios.post(
        api + "/print/daily/sheet",
        { date: data.date, selections: data.selections },
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Fiche Journalière " + data.date + ".pdf");
      link.click();
    } catch (error) {
      console.error(error);
    }
  },

  async fetchTotalTodays({ commit }) {
    try {
      axios.get(api + "/total/todays").then((response) => {
        commit("setTotalTodays", response.data);
      });
    } catch (error) {
      console.error(error);
    }
  },

  async fetchTotals({ commit }) {
    try {
      axios.get(api + "/totals").then((response) => {
        commit("SET_TOTALS", response.data);
      });
    } catch (error) {
      console.error(error);
    }
  },

  async fetchQuantityAnalytics({ commit }, data) {
    await this.$api
      .create(api + "/quantity/analytics", data, { confirm: false })
      .then((response) => {
        commit("SET_QUANTITY_ANALYTICS", response.data);
      });
  },

  async fetchDeliveries({ commit }) {
    try {
      axios.get(api + "/deliveries").then((response) => {
        commit("setDeliveries", response.data);
      });
    } catch (error) {
      console.error(error);
    }
  },
};

// mutations
const mutations = {
  SET_TOTALS(state, data) {
    state.totals = data;
  },
  setTotalTodays(state, data) {
    state.totalTodays = data;
  },
  SET_QUANTITY_ANALYTICS(state, data) {
    state.quantityAnalytics = data;
  },
  setDeliveries(state, data) {
    state.deliveries = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
